export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const decodeBase64 = (b64) => {
      if (typeof atob === "function") return atob(b64);
      if (typeof Buffer !== "undefined") {
        return Buffer.from(b64, "base64").toString("binary");
      }
      throw new Error("No base64 decoder available");
    };
    const binary = decodeBase64(padded);
    const json = decodeURIComponent(
      binary
        .split("")
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function deriveUserFromToken(token) {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;
  const roles = [];
  if (payload.role) roles.push(payload.role);
  return {
    id: payload.userId ?? null,
    email: payload.sub ?? payload.email ?? null,
    businessId: payload.businessId ?? null,
    roles,
  };
}
